import { MenuItem, Select, Stack, Typography } from '@mui/material'
import { useEffect, useState } from 'react'

import { useDevices } from '../Contexts/DevicesContext'

const SelectDevice = ({ setDevice = () => { } }) => {

  const { useFetchDevices } = useDevices()

  const [trackers, setTrackers] = useState([])
  const [selectedDevice, setSelectedDevice] = useState(null)

  useEffect(() => {
    useFetchDevices(1).then((res) => {
      setTrackers(res.data)
    })
  }, [])

  const handleSelectDevice = (event) => {
    setSelectedDevice(event.target.value)
    setDevice(event.target.value)
  }

  return (
    <>
      <Stack
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        rowGap={2}
        padding={5}
      >
        <Typography variant="h5" fontWeight="bold" textAlign={'center'}>
          Seleziona un tracker dalla lista
        </Typography>

        <Stack
          display="flex"
          flexDirection="column"
          alignItems="flex-start"
          rowGap={1}
          width="100%"
          maxWidth="400px"
        >
          <Select
            label="Nome Tracker"
            value={selectedDevice}
            fullWidth
            onChange={handleSelectDevice}
          >
            {trackers.sort((a, b) => a.name.localeCompare(b.name, 'it')).map((key, i) => (
              <MenuItem
                key={`device-${i}`}
                value={key}
              >
                {key.name}
              </MenuItem>
            ))}
          </Select>
        </Stack>
      </Stack>
    </>
  )
}

export default SelectDevice